import UserSettings from '../Settings/userSettings';
import { publish } from './utils/pubsub';
import logService from './wss/logService3';
import { events } from './wss/SystemEvents';

const _name = 'ReconnectManager';
const FIRST_RETRY_DELAY_MS = 5000; // 5s — covers Wifi blip
const RETRY_INTERVAL_MS = 30000; // 30s — covers redeploy

class ReconnectManager {
    constructor() {
        this._retryCount = 0;
        this._timer = null;
    }

    /**
     * @param {*} SystemStreamer
     */
    init = (streamer) => {
        this._streamer = streamer;
    };

    /**
     * Called by SystemStreamer on disconnect — schedules first retry after 5s
     */
    schedule = () => {
        // Already scheduled — ignore duplicate disconnect events
        if (this._timer !== null) {
            return;
        }

        this._retryCount = 0;
        logService.log(`${_name}.schedule: first retry in ${FIRST_RETRY_DELAY_MS}ms`);

        this._timer = setTimeout(() => {
            this._timer = null;
            this._attempt();
        }, FIRST_RETRY_DELAY_MS);
    };

    /**
     * Attempt reconnect — on failure schedules next retry at 30s interval
     * Stops after maxConnectionRetries and notifies user
     */
    _attempt = async () => {
        this._retryCount++;
        const max = UserSettings.maxConnectionRetries;

        logService.log(`${_name}._attempt: try ${this._retryCount}/${max}`);

        try {
            const success = await this._streamer.start();

            if (success) {
                // const payload = messageFactory.createRequest('reconnectToken', token);
                // const msg = messageFactory.serialize(payload);
                // await this._streamer.send(msg);

                this._onReconnectSuccess();
                return;
            }

            this._onReconnectFailed(max);
        } catch (ex) {
            logService.logError(`${_name}._attempt: ex=${ex.message}`);
            this._onReconnectFailed(max);
        }
    };

    _onReconnectSuccess = () => {
        logService.log(`${_name}._onReconnectSuccess: reconnected after ${this._retryCount} tries`);

        publish(events.onReconnected);

        this._retryCount = 0;
    };

    _onReconnectFailed = (max) => {
        if (this._retryCount >= max) {
            logService.logError(`${_name}._onReconnectFailed: max retries (${max}) reached, giving up`);
            publish('SystemSocketReconnectFailed');
            this._retryCount = 0;
            return;
        }

        logService.log(`${_name}._onReconnectFailed: next retry in ${RETRY_INTERVAL_MS}ms`);
        this._timer = setTimeout(() => {
            this._timer = null;
            this._attempt();
        }, RETRY_INTERVAL_MS);
    };

    /**
     * Cancel any pending retry — call on deliberate disconnect
     */
    cancel = () => {
        if (this._timer !== null) {
            clearTimeout(this._timer);
            this._timer = null;
        }
        this._retryCount = 0;
        logService.log(`${_name}.cancel: reconnect cancelled`);
    };
}

const reconnectManager = new ReconnectManager();
export default reconnectManager;
